import * as React from 'react'
import { b, O, pipe, RA, s } from '@packages/prelude'
import { type AccordionEventKey } from 'react-bootstrap/esm/AccordionContext'

export interface UseCurrentRecorderResult {
  currentRecorder: O.Option<string>
  onIsRecording: (key: string) => (isRecording: boolean) => void
  onAccordionSelect: (key: AccordionEventKey) => void
  reset: () => void
}

export const useCurrentRecorder = (): UseCurrentRecorderResult => {
  const [currentRecorder, setCurrentRecorder] = React.useState<O.Option<string>>(O.none)

  const onIsRecording = React.useCallback(
    (key: string) => (isRecording: boolean) =>
      pipe(
        isRecording,
        b.match(
          () => setCurrentRecorder(prev => (O.elem(s.Eq)(key, prev) ? O.none : prev)),
          () => setCurrentRecorder(O.some(key))
        )
      ),
    []
  )

  const onAccordionSelect = React.useCallback((key: AccordionEventKey) => {
    pipe(
      key,
      O.fromNullable,
      O.map(a => [a].flat()),
      O.chain(RA.head),
      setCurrentRecorder
    )
  }, [])

  const reset = React.useCallback(() => setCurrentRecorder(O.none), [])

  return { currentRecorder, onIsRecording, onAccordionSelect, reset }
}
